
import {of as observableOf,  Observable } from 'rxjs';

import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ILanguages } from '@shared/services/api/legacy/languages-service/languages-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';

@Injectable()
export class LanguagesService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${LanguagesService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/languages';

    public getLanguageSettings(): Observable<SuccessResponse<ILanguages> | ErrorResponse> {
        return this.http
        .get<SuccessResponse<ILanguages>>(LanguagesService.URL).pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public setLanguageSettings(languages: ILanguages): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
        .put<SuccessResponse<boolean>>(LanguagesService.URL, languages).pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
